"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var formateUtil_1 = require("../../util/formateUtil");
//金币映射
var coinResourceMap = {
    0: 'coin',
    1: 'yx',
    2: 'zw'
};
var timer = null;
var timer2 = null;
var Interactive = /** @class */ (function () {
    function Interactive() {
        this.callBackGetApi = undefined;
        this.receiveCoin = []; //可令金币
        this.goldCoinTime = 0;
        this.resourceStatus = true;
        this.firstLoad = false;
        this.timeStart = 0;
        this.placeCoin = null;
        this.handleEventTab = null;
        this.waiteDialogBoxFn = null;
        this.nextPopup = true;
        this.currentPopup = false; //当前是否有等待的任务
        this.opportunityMap = {
            click_mask_skip: '气泡引导蒙层点击跳过时',
            after_base_score_display: '基础分气泡曝光 N 秒时',
            first_activation: '首次激活弹窗关闭时',
            after_marketing_taskbar_display: '营销任务栏曝光 N 秒时',
            upgrade_dialog_closed: '升级弹窗关闭时',
            page_loading: '页面载入时',
            click_cat: '点击猫猫时',
            atfer_receivable_score_display: '可领金币曝光 N 秒时'
        };
        this.coinList = [];
        this.recordPageVisible = false; //页面可见的情况
        this.pageVisibleFn();
    }
    //记录可见时间
    Interactive.prototype.pageVisible = function () {
        this.timeStart = new Date().getTime();
    };
    // 金币填充时间
    Interactive.prototype.setGoldCoinInfo = function (list) {
        return __awaiter(this, void 0, void 0, function () {
            var Coins, removes, _a, removes_1, _i, coin, _b, _c, _d, index, _item, coin;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.receiveCoin = [];
                        Coins = require('../goldCoin').default;
                        removes = [5, 4, 3, 2, 1].slice(0, 5 - list.length);
                        for (_a = 0, removes_1 = removes; _a < removes_1.length; _a++) {
                            _i = removes_1[_a];
                            coin = Coins.coins['key' + _i];
                            coin.remove();
                        }
                        this.coinList = list;
                        _b = [];
                        for (_c in list)
                            _b.push(_c);
                        _d = 0;
                        _e.label = 1;
                    case 1:
                        if (!(_d < _b.length)) return [3 /*break*/, 6];
                        index = _b[_d];
                        _item = list[index];
                        coin = Coins.coins['key' + (Number(index) + 1)];
                        // 筛选不存在的数据
                        if (_item.taskId < 0) {
                            coin.remove();
                            return [3 /*break*/, 5];
                        }
                        if (!coin || _item.id === coin.id) {
                            return [3 /*break*/, 5];
                        }
                        // await coin.isReadyOver();
                        //可领取的金币统计
                        if (_item.bubbleType === 0) {
                            this.receiveCoin.push(coin);
                            if (_item.taskId === 104 || _item.taskId === 101) {
                                if (!timer) {
                                    clearTimeout(timer2);
                                    timer = setTimeout(function () {
                                        // 可领金币曝光 N 秒时对话框
                                        _this.handleEventTab && _this.handleEventTab('after_base_score_display');
                                        timer = null;
                                    }, 6000);
                                }
                            }
                            else {
                                if (!timer2) {
                                    timer2 = setTimeout(function () {
                                        // 可领金币曝光 N 秒时对话框
                                        _this.handleEventTab && _this.handleEventTab('atfer_receivable_score_display');
                                        timer2 = null;
                                    }, 6000);
                                }
                            }
                        }
                        //填充coin数据
                        return [4 /*yield*/, coin.setCoinResourceAndType(coinResourceMap[_item.bubbleType], _item.title, _item.score, _item.bubbleType, _item, index)];
                    case 2:
                        //填充coin数据
                        _e.sent();
                        if (!!this.firstLoad) return [3 /*break*/, 4];
                        return [4 /*yield*/, coin.play(index)];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        //几录第一个是否是占位金币
                        if (Number(index) === 0 && (_item.bubbleType === 1 || _item.bubbleType === 2)) {
                            this.placeCoin = coin;
                        }
                        _e.label = 5;
                    case 5:
                        _d++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.firstLoad = true;
                        //统计可领取金币
                        this.goldCoinTime = list.filter(function (_item) { return _item.bubbleType === 0; }).length;
                        //轮询闪动
                        this.rotationCoinShake();
                        return [2 /*return*/];
                }
            });
        });
    };
    // 注册猫咪的点击回调
    Interactive.prototype.catClickRegister = function (fn) {
        this.catClickFn = fn;
    };
    // 猫咪的点击触发
    Interactive.prototype.catClickControl = function () {
        this.catClickFn && this.catClickFn();
    };
    //循环播放coin 闪动
    Interactive.prototype.rotationCoinShake = function () {
        return __awaiter(this, void 0, void 0, function () {
            var index, len, _a, _b, i;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        index = 0, len = this.receiveCoin.length;
                        _a = 0, _b = this.receiveCoin;
                        _c.label = 1;
                    case 1:
                        if (!(_a < _b.length)) return [3 /*break*/, 5];
                        i = _b[_a];
                        if (!(i && i.playShake)) return [3 /*break*/, 3];
                        if (i.coinSpriteAnimation.resource !== 'shine') {
                            return [3 /*break*/, 4];
                        }
                        return [4 /*yield*/, i.playShake()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        index++;
                        if (index === len) {
                            this.rotationCoinShake();
                        }
                        _c.label = 4;
                    case 4:
                        _a++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    //2d 动画触发和3d动画的事件
    Interactive.prototype.coinClick = function (index) {
        var Coins = require('../goldCoin').default;
        var coin = Coins.coins['key' + (index + 1)];
        coin.coinClickCallback();
    };
    //触发猫咪的招手
    Interactive.prototype.helloAction = function () {
        var cat = require('../cat').default;
        cat.switchAnimation('hello', 1, function () {
            cat.switchAnimation('loop', Infinity);
        });
    };
    //等待队列
    Interactive.prototype.waiteWakePopup = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.nextPopup) {
                resolve(true);
            }
            _this.waiteDialogBoxFn = resolve;
        });
    };
    // 允许下个场景
    Interactive.prototype.applayPopup = function (applay) {
        this.waiteDialogBoxFn && this.waiteDialogBoxFn(applay);
        this.nextPopup = applay;
        return this.currentPopup;
    };
    //唤起对话框
    Interactive.prototype.wakePopups = function (list, scene) {
        return __awaiter(this, void 0, void 0, function () {
            var cat;
            return __generator(this, function (_a) {
                console.log(scene, list, 8888);
                this.currentPopup = true;
                this.waiteWakePopup();
                this.currentPopup = false;
                this.nextPopup = false;
                cat = require('../cat').default;
                cat.speak(list, scene);
                return [2 /*return*/];
            });
        });
    };
    //通知已经曝光过这个弹窗
    Interactive.prototype.notifySceneWordDisplayPopup = function () {
    };
    Interactive.prototype.getPlaceCoin = function (value) {
        if (this.placeCoin) {
            this.placeCoin.goldCoinIndex.zIndex = value;
        }
    };
    //领基础分触发金币的tip
    Interactive.prototype.showBasicScoreGuide = function (index) {
        var Coins = require('../goldCoin').default;
        //金币实例
        var coin = Coins.coins['key' + (index + 1)];
        coin.setTip2({ desc: '领取激活奖励，可获额外活力值' });
    };
    //金币结束事件 和点击事件
    Interactive.prototype.coinFallOve = function (position, index, type, data) {
        var cat = require('../cat').default;
        //隐藏对话框
        cat.catClickHideDialogBox();
        var Coins = require('../goldCoin').default;
        [0, 1, 2, 3, 4].forEach(function (item) {
            if (item != Number(index)) {
                Coins.coins['key' + (item + 1)].clearTip();
            }
        });
        return this.callBackGetApi && this.callBackGetApi(position, index, type, data);
    };
    //注册对话框出现时机的事件
    Interactive.prototype.registerEventFunction = function (callBack) {
        this.handleEventTab = callBack;
    };
    //注册回调
    Interactive.prototype.registerFunction = function (callBackGetApi) {
        this.callBackGetApi = callBackGetApi;
    };
    Interactive.prototype.setStatus = function (value) {
        this.resourceStatus = value;
        // this.setResolve&&this.setResolve(value)
    };
    Interactive.prototype.cat3dGrayscale = function (_gray) {
        var _this = this;
        this.switch3d = this.versionCompare && _gray && this.resourceStatus;
        return new Promise(function (resolve, reject) {
            resolve(_this.switch3d);
        });
    };
    Object.defineProperty(Interactive.prototype, "versionCompare", {
        get: function () {
            // @ts-ignore
            if (window.PPDWebUI && window.PPDWebUI.os.android) {
                return (0, formateUtil_1.compareVersionEle)(this.getAndroidVersion(), '6.0.0');
                // @ts-ignore
            }
            else if (window.PPDWebUI && window.PPDWebUI.os.ios) {
                return (0, formateUtil_1.compareIos)('10.0.0');
            }
            else {
                return true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Interactive.prototype.getAndroidVersion = function (ua) {
        ua = (ua || navigator.userAgent).toLowerCase();
        var match = ua.match(/android\s([0-9\.]*)/);
        return match ? match[1] : false;
    };
    Interactive.prototype.pageVisibleFn = function () {
        var _this = this;
        // @ts-ignore
        if (window.PPDWebUI && window.PPDWebUI.os.inApp && window.PPDWebUI.ListenerService && window.PPDWebUI.ListenerService.resumeListener) {
            // @ts-ignore
            window.PPDWebUI.ListenerService.resumeListener(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _item;
                var _this = this;
                return __generator(this, function (_c) {
                    if (this.recordPageVisible) {
                        for (_a = 0, _b = this.coinList; _a < _b.length; _a++) {
                            _item = _b[_a];
                            if (_item.bubbleType === 0) {
                                if (_item.taskId === 104 || _item.taskId === 101) {
                                    if (!timer) {
                                        clearTimeout(timer2);
                                        timer = setTimeout(function () {
                                            // 可领金币曝光 N 秒时对话框
                                            _this.handleEventTab && _this.handleEventTab('after_base_score_display');
                                            timer = null;
                                        }, 6000);
                                    }
                                }
                                else {
                                    if (!timer2) {
                                        timer2 = setTimeout(function () {
                                            // 可领金币曝光 N 秒时对话框
                                            _this.handleEventTab && _this.handleEventTab('atfer_receivable_score_display');
                                            timer2 = null;
                                        }, 6000);
                                    }
                                }
                            }
                        }
                    }
                    this.recordPageVisible = true;
                    return [2 /*return*/];
                });
            }); });
        }
    };
    return Interactive;
}());
var InteractiveController = new Interactive();
exports.default = InteractiveController;
